// authConfig.js
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: process.env.REACT_APP_AUTHORITY,
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
    postLogoutRedirectUri: process.env.REACT_APP_REDIRECT_URI,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};

// Scope of Feelim's own API (exposed by this same app registration). The access token for it
// is requested silently by utils/apiFetch.js, not at login, so the login flow is unchanged.
export const apiScopes = [`api://${process.env.REACT_APP_CLIENT_ID}/access_as_user`];
